import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["detail", "chevronIcon", "toggle"]
  static values = {
    confirmDisableMessage: { type: String, default: "Weet je zeker dat je deze harde regel wilt uitschakelen? Het rooster kan niet meer gegarandeerd aan deze eis voldoen." }
  }

  toggleDetail() {
    const detail = this.detailTarget
    const icon = this.chevronIconTarget

    if (detail.classList.contains("hidden")) {
      detail.classList.remove("hidden")
      icon.classList.add("rotate-180")
    } else {
      detail.classList.add("hidden")
      icon.classList.remove("rotate-180")
    }
  }

  confirmHardToggle(event) {
    const checkbox = event.target
    if (!checkbox.checked) {
      const confirmed = confirm(this.confirmDisableMessageValue)
      if (!confirmed) {
        checkbox.checked = true
        return
      }
    }
    this.submitForm(event)
  }

  submitForm(event) {
    const form = event.target.closest("form")
    if (form) form.requestSubmit()
  }
}
